/**
 * Created by alvinoktavianus on 6/27/17.
 */

import {
  INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON,
  INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON,
  INGREDIENT_SUBSCRIPTION_END_TUTORIAL,
  INGREDIENT_SUBSCRIPTION_FEATURE_PRICE,
  INGREDIENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS,
  INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE,
  INGREDIENT_SUBSCRIPTION_GET_BILLINGS,
  INGREDIENT_SUBSCRIPTION_GET_OUTLETS,
  INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL,
  INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  INGREDIENT_SUBSCRIPTION_PAGE_REQUEST,
  INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE,
  INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT,
  INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE,
  INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS,
  INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL,
  INGREDIENT_SUBSCRIPTION_SET_OUTLETS,
  INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE,
  INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE,
  INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL,
  INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL,
  INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  INGREDIENT_SUBSCRIPTION_START_TRIAL,
  INGREDIENT_SUBSCRIPTION_SUBSCRIPTION_STATUS,
  INGREDIENT_SUBSCRIPTION_VERIFY_BILLING,
} from './constant';

// Default dispatch
export function pageRequest(
  trialEndAt,
  outletSlot,
  billingNotification,
  alreadySubscribed
) {
  return {
    type: INGREDIENT_SUBSCRIPTION_PAGE_REQUEST,
    payload: { trialEndAt, outletSlot, billingNotification, alreadySubscribed },
  };
}

export function featurePricePerMonths() {
  return {
    type: INGREDIENT_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS,
  };
}

export function featurePrice(trialEndAt, outletSlot, alreadySubscribed) {
  return {
    type: INGREDIENT_SUBSCRIPTION_FEATURE_PRICE,
    payload: { trialEndAt, outletSlot, alreadySubscribed },
  };
}

export function subscriptionStatus() {
  return {
    type: INGREDIENT_SUBSCRIPTION_SUBSCRIPTION_STATUS,
  };
}

export function finishLoadingPage() {
  return {
    type: INGREDIENT_SUBSCRIPTION_FINISH_LOADING_PAGE,
  };
}

export function endTutorial(featureName, businessId) {
  return {
    type: INGREDIENT_SUBSCRIPTION_END_TUTORIAL,
    payload: { featureName, businessId },
  };
}

export function verifyBilling(billingData) {
  return {
    type: INGREDIENT_SUBSCRIPTION_VERIFY_BILLING,
    payload: { billingData },
  };
}

export function startTrial() {
  return {
    type: INGREDIENT_SUBSCRIPTION_START_TRIAL,
  };
}

// Setter
export function setIsOnTutorial(isOnTutorial) {
  return {
    type: INGREDIENT_SUBSCRIPTION_SET_IS_ON_TUTORIAL,
    payload: { isOnTutorial },
  };
}

export function setFeaturePricePerMonths(featurePricePerMonths) {
  return {
    type: INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS,
    payload: { featurePricePerMonths },
  };
}

export function setFeaturePrice(featurePrice) {
  return {
    type: INGREDIENT_SUBSCRIPTION_SET_FEATURE_PRICE,
    payload: { featurePrice },
  };
}

export function setPendingPaymentMessage(pendingPaymentMessage) {
  return {
    type: INGREDIENT_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE,
    payload: { pendingPaymentMessage },
  };
}

export function setPendingOutletMessage(pendingOutletMessage) {
  return {
    type: INGREDIENT_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE,
    payload: { pendingOutletMessage },
  };
}

export function setSubscriptionDetail(subscriptionDetail) {
  return {
    type: INGREDIENT_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL,
    payload: { subscriptionDetail },
  };
}

export function setCurrentOutletCount(currentOutletCount) {
  return {
    type: INGREDIENT_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT,
    payload: { currentOutletCount },
  };
}

export function setOutlets(outlets) {
  return {
    type: INGREDIENT_SUBSCRIPTION_SET_OUTLETS,
    payload: { outlets },
  };
}

export function setPayButtonMessage(buttonMessage) {
  return {
    type: INGREDIENT_SUBSCRIPTION_SET_BUTTON_MESSAGE,
    payload: { buttonMessage },
  };
}

// Getter
export function getBillings() {
  return {
    type: INGREDIENT_SUBSCRIPTION_GET_BILLINGS,
  };
}

export function getOutlets() {
  return {
    type: INGREDIENT_SUBSCRIPTION_GET_OUTLETS,
  };
}

// Other dispatch
export function enablePayButton() {
  return {
    type: INGREDIENT_SUBSCRIPTION_ENABLE_PAY_BUTTON,
  };
}

export function disablePayButton() {
  return {
    type: INGREDIENT_SUBSCRIPTION_DISABLE_PAY_BUTTON,
  };
}

export function showDetailTransactionModal() {
  return {
    type: INGREDIENT_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL,
  };
}

export function hideDetailTransactionModal() {
  return {
    type: INGREDIENT_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL,
  };
}

export function showPaymentGatewayErrorModal() {
  return {
    type: INGREDIENT_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  };
}

export function hidePaymentGatewayErrorModal() {
  return {
    type: INGREDIENT_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  };
}
